import Swiper from 'swiper';

export default function initCategoriesNav(): void {
    const $categoriesNav = document.querySelectorAll<HTMLElement>('.js-categories-nav-slider');

    $categoriesNav.forEach($container => {
        new CategoriesNav($container);
    });
}

class CategoriesNav {
    $el: HTMLElement | null | undefined;
    swiper: Swiper | null = null;


    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.init();
    }

    init(): void {
        this.initSlider();
    }


    initSlider(): void {
        if (this.$el) {
            this.swiper = new Swiper(this.$el, {
                slidesPerView: 'auto',
                spaceBetween: 40,
                grabCursor: true,
            });
        }
    }
}
